class r extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector('input[type="search"]')),
      (this.predictiveSearchResults = document.getElementById(
        this.dataset.selector
      )),
      this.input.addEventListener(
        "input",
        this.debounce((t) => {
          this.onChange(t);
        }, 300).bind(this)
      );
  }
  onChange() {
    const t = this.input.value.trim();
    if (!t.length) {
      this.close();
      return;
    }
    this.getSearchResults(t);
  }
  getSearchResults(t) {
    fetch(
      `${window.Shopify.routes.root}search/suggest?q=${t}&section_id=predictive-search`
    )
      .then((e) => {
        if (!e.ok) {
          var s = new Error(e.status);
          throw (this.close(), s);
        }
        return e.text();
      })
      .then((e) => {
        const s = new DOMParser()
          .parseFromString(e, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        (this.predictiveSearchResults.innerHTML = s), this.open();
      })
      .catch((e) => {
        throw (this.close(), e);
      });
  }
  open() {
    this.predictiveSearchResults.style.display = "block";
  }
  close() {
    this.predictiveSearchResults.style.display = "none";
  }
  debounce(t, e) {
    let s;
    return (...i) => {
      clearTimeout(s), (s = setTimeout(() => t.apply(this, i), e));
    };
  }
}
customElements.define("drop-search", r);
